<div class="terms">
    <iframe src="https://app.termly.io/document/terms-and-conditions/d5854f54-8014-4b70-a27c-6717f92c555c" width="100%"
        height="10400px" frameborder="0"></iframe>
</div>

<div class="terms__message-holder" *ngIf="!isShowterms && currentLanguage == 'ar'">
    <div class="terms__message-info">
        <h3 class="terms__info-title">
            هذا المحتوى متوفر باللغة الإنجليزية
        </h3>
        <a (click)="showTerms()">Terms Of Use</a>
    </div>
</div>